<div #navContainer class="nav-container" [ngStyle]="getNavContainerStyle()">
  @for (child of children; track $index; let idx = $index) {
    <div
      class="nav-button"
      (click)="navClick({ idx: idx, child: child, event: $event })"
      (mouseenter)="hoverNav[idx] = true"
      (mouseleave)="hoverNav[idx] = false"
      [ngStyle]="getNavStyle(idx)"
    >
      {{ child.fileName }}
    </div>
  }
</div>
